'use client';
import { __rest } from 'tslib';
import { styled } from '../stitches.config.js';
import React, { forwardRef, useId } from 'react';
import { Label } from './Label.js';

const inputLayoutStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    padding: 8,
    lineHeight: 1,
    minWidth: 0,
};
const InputWrapper = styled('span', {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    position: 'relative',
    background: 'inherit',
    gridArea: 'input',
});
const InputField = styled('input', Object.assign(Object.assign({ all: 'unset' }, inputLayoutStyle), { boxShadow: '$boxShadow', backgroundColor: '$overlayB11', color: '$primary12', '&:focus': { boxShadow: `$focus`, scale: 1.02, }, variants: {
        size: {
            'small': {
                fontSize: '0.85em',
                padding: 6,
            },
        },
        error: {
            true: {
                boxShadow: '$error',
            }
        },
        valid: {
            true: {
                boxShadow: '$success',
            }
        },
        design: {
            invisible: {
                boxShadow: 'none',
                backgroundColor: 'inherit',
            },
            solid: {
                backgroundColor: '$loContrast',
            },
            native: {
                all: 'revert',
                // margin: '5px',
                padding: 3,
                '&:focus': { boxShadow: 'initial', scale: 'initial' },
            }
        }
    } }));
const Col = styled('span', {
    position: 'relative',
    padding: 0,
    margin: 0,
    display: 'inline-flex',
    flexDirection: 'column',
});
const Input = forwardRef((_a, forwardedRef) => {
    var _b;
    var { outerCSS, children, label, type = 'text', error, labelSize = 5, valid = false } = _a, props = __rest(_a, ["outerCSS", "children", "label", "type", "error", "labelSize", "valid"]);
    const id = useId();
    return (React.createElement(InputWrapper, { css: outerCSS },
        label && React.createElement(Label, { size: labelSize, htmlFor: id }, label),
        React.createElement(Col, { css: outerCSS },
            React.createElement(InputField, Object.assign({ error: error, valid: valid, id: (_b = props.id) !== null && _b !== void 0 ? _b : id, type: type, ref: forwardedRef }, props)),
            children)));
});
Input.displayName = 'Input';

export { Input, InputField, InputWrapper, inputLayoutStyle };
